import React, { Component } from 'react'
import Footer from '../footer/footer'
import data from '../../mock/blog-mock.json'

export default class Blog extends Component {
  constructor () {
    super()

    this.state = {
      data: []
    }
  }

  componentWillMount () {
    this.setState({
      data: data
    })
  }

  gotToPost (selectedPost) {
    return this.props.history.push({
      pathname: `/post/${selectedPost}` 
    })
  }

  renderPost (boxItem, index) {
    return (
      <article className="postBox" key={index}>
        <div
          className="thumb"
          style={{backgroundImage: `url(/imgs/${boxItem.img})`}}
          onClick={() => this.gotToPost(boxItem.index)}>
        </div>
        <div className="bottom">
          <a className="title">{boxItem.title}</a>
          <div className="footerBox">
            <span className="views">
              <i className="fa fa-eye"></i>
              {boxItem.views}
            </span>
            <a>Escreva um comentário</a>
            <span className="like">
              <i className="fa fa-heart"></i>
            </span>
          </div>
        </div>
      </article>
    )
  }

  render() {
    const post = this.state.data

    return (
      <div className="fullHeight">
        <section id="Blog" className="clear">
          <header>
            <div className="container squad">
              <h2 className='h2-custom'>Notícias</h2>
            </div>
          </header>

          <div className="boxPostContainer">
            <div className="squad">
              {post.map((post, index) => (this.renderPost(post, index)))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    )
  }

  componentDidMount () {
    window.scroll(0, 0)
  }
}



// WEBPACK FOOTER //
// ./src/components/blog/blog.js